import { cancelPlaceSelection } from "../../../app/api/cancelPlaceSelection";
import { BaseAction } from "../../../core/actions/BaseAction";

class CancelPlaceSelectionAction extends BaseAction<void, { bookingId: string }> {
  override async run(): Promise<void> {
    try {
      const { bookingId } = this.params!;

      if (!bookingId) {
        console.log("CancelPlaceSelectionAction: bookingId is required");
        return;
      }

      const response: any = await cancelPlaceSelection(bookingId);
      if (response.status === 'ok' && response.answer) {
      }
    } catch (error) {
      console.log("Error in CancelPlaceSelectionAction:", error);
    }
  }
}

export const cancelPlaceSelectionAction = new CancelPlaceSelectionAction();
